import script from "./PortfolioOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioOverview.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioOverview.vue?vue&type=style&index=0&id=5cc2252f&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc2252f"]])

export default __exports__